import axios, { AxiosResponse } from 'axios';
import { API_BASE_URL } from 'src/helper/constants';
import { apiCatchHandlerNoData } from 'src/helper/utils';
import { IMyDownloads } from './my-downloads-types';

export const getAllMyDownloads = (successCallback: (response: IMyDownloads[]) => void, errorCallback: () => void) => {
	axios
		.get(`${API_BASE_URL}/api/mydownload/get-all-my-download`)
		.then((response: AxiosResponse<IMyDownloads[]>) => {
			const { data } = response;
			successCallback(data);
		})
		.catch((error) => {
			apiCatchHandlerNoData(error, errorCallback);
		});
};

export function getMyDownloadFileUri(
	storageAccountId: number,
	fileName: string,
	filePath: string,
	successCallback: (uri: string) => void,
	errorCallback: () => void,
) {
	axios
		.get(
			`${API_BASE_URL}/api/mydownload/download-zip?storageAccountId=${storageAccountId}&fileName=${fileName}&filePath=${filePath}`,
		)
		.then((response: AxiosResponse<string>) => {
			const { data } = response;
			successCallback(data);
		})
		.catch((error) => {
			apiCatchHandlerNoData(error, errorCallback);
		});
}

export const deleteMyDownload = (
	myDownloadId: number,
	successCallback: (response: boolean) => void,
	errorCallback: () => void,
) => {
	axios
		.delete(`${API_BASE_URL}/api/mydownload/delete-my-download?myDownloadId=` + myDownloadId)
		.then((response: AxiosResponse<boolean>) => {
			const { data } = response;
			successCallback(data);
		})
		.catch((error) => {
			apiCatchHandlerNoData(error, errorCallback);
		});
};

export const clearAll = (successCallback: (response: boolean) => void, errorCallback: () => void) => {
	axios
		.delete(`${API_BASE_URL}/api/mydownload/clear-all`)
		.then((response: AxiosResponse<boolean>) => {
			const { data } = response;
			successCallback(data);
		})
		.catch((error) => {
			apiCatchHandlerNoData(error, errorCallback);
		});
};

export const retry = (myDownloadId: number, successCallback: () => void, errorCallback: () => void) => {
	axios
		.post(`${API_BASE_URL}/api/mydownload/retry?myDownloadId=` + myDownloadId)
		.then((response: AxiosResponse<boolean>) => {
			successCallback();
		})
		.catch((error) => {
			apiCatchHandlerNoData(error, errorCallback);
		});
};
